export default __webpack_public_path__ + "static/media/(30).aadbd1e1.JPG";